import { l } from '@manychat/manyui'

import { KnowledgeErrorCode } from 'shared/api/requests/aiBusinessKnowledge/schemas'

export const getErrorContent = (
  code: KnowledgeErrorCode,
): { title: string; description: string } | null => {
  switch (code) {
    case KnowledgeErrorCode.PARSING_ERROR: {
      return {
        title: l.translate('Can’t read this link'),
        description: l.translate(
          'The content couldn’t be processed. Delete the entry and try a different link.',
        ),
      }
    }
    case KnowledgeErrorCode.BLACK_LISTED_DOMAIN: {
      return {
        title: l.translate('Link can’t be used'),
        description: l.translate(
          'This domain is restricted.  Delete the entry and try a different link.',
        ),
      }
    }
    case KnowledgeErrorCode.INTERNAL_ERROR: {
      return {
        title: l.translate('Something went wrong'),
        description: l.translate(
          'There was an error while processing.  Delete the entry and try again',
        ),
      }
    }
    default:
      return null
  }
}
